import { createUseStyles } from 'react-jss';

import { Transitions, BorderRadiuses, Spacings, BreakPoints } from '@picsart/rc/enums';
import { FontSizes, FontWeights } from '@picsart/rc/fonts';
import { mediaQuery } from '@picsart/rc/helpers';

const useNotFoundStyles = createUseStyles(
  {
    main: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: FontSizes.Size_10,
      margin: '60px 0',
      width: '100%',

      '& > p': {
        marginTop: '20px',
        textAlign: 'center',
      },

      img: {
        [mediaQuery(BreakPoints.Medium)]: {
          width: '312px',
          height: '136px',
        },
      },
    },
    img: {},
    homeBtn: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'var(--primary-base-default)',
      width: '256px',
      height: '56px',
      padding: `0 ${Spacings.Size_8}px`,
      border: 'none',
      borderRadius: `${BorderRadiuses.Size_3}px`,
      backgroundSize: '200% 200%',
      backgroundPosition: '0% 100%',
      fontWeight: FontWeights.Bold,
      fontSize: FontSizes.Size_8,
      color: '#fff',
      lineHeight: '16px',
      transition: `all ${Transitions.Default} ease-in-out`,
      transform: 'translate3d(0, 0, 0)',

      marginTop: 30,
    },
  },
  {
    name: 'not-found',
  },
);

export default useNotFoundStyles;
